// tslint:disable:no-any
import * as React from 'react';
import { Redirect } from 'react-router';
import { observer } from 'mobx-react';
import { UserNotificationStore } from './UserNotificationStore';

export interface IUserNotificationsProps {}
interface IUserNotificationsState {
    opened: boolean;
}

@observer
class UserNotifications extends React.Component<
    IUserNotificationsProps,
    IUserNotificationsState
> {
    protected store = UserNotificationStore.getInstance();
    private timerClose: NodeJS.Timer | null = null;

    constructor(props: IUserNotificationsProps) {
        super(props);
        this.state = {
            opened: false
        };

        this.timerClose = null;
    }

    public componentDidMount() {
        this.store.refreshNotifications();
    }

    onClickBell(e: Event) {
        if (this.store.notifications.length === 0) {
            return;
        }

        this.store.notifications.map(notify => {
            notify.redirect = false;
        });

        let newOpened = this.state.opened !== true ? true : false;
        this.setState({
            opened: newOpened
        });

        e.preventDefault();
    }

    onClickNotify(e: Event, index: number) {
        this.store.notifications.forEach((notify, i) => {
            if (i === index && notify.link !== null) {
                notify.redirect = true;
            }
        });

        e.preventDefault();
        e.stopPropagation();
    }

    onMouseLeave() {
        this.timerClose = setTimeout(() => {
            this.setState({ opened: false });
            this.timerClose = null;
        }, 700);
    }

    onMouseEnter() {
        if (this.timerClose !== null) {
            clearTimeout(this.timerClose);
            this.timerClose = null;
        }
    }

    render() {
        return (
            <div
                className={
                    'profileHolder__notifications' +
                    (this.store.notifications.length > 0 ? ' filled' : '')
                }
                onMouseLeave={() => this.onMouseLeave()}
                onMouseEnter={() => this.onMouseEnter()}
            >
                <div
                    className={
                        'dropdown-title' + (this.state.opened ? ' opened' : '')
                    }
                    onClick={e => this.onClickBell(e as any)}
                >
                    <div className="bell">
                        {this.store.notifications.length > 0 && (
                            <div className="counts">
                                {this.store.notifications.length}
                            </div>
                        )}
                    </div>
                    <div className="transparent-border" />
                    {this.store.notifications.length > 0 && (
                        <ul className="dropdown">
                            {this.store.notifications.map((notify, index) => {
                                return (
                                    <li
                                        key={index}
                                        onClick={e =>
                                            this.onClickNotify(e as any, index)
                                        }
                                    >
                                        {notify.redirect && (
                                            <Redirect to={notify.link as any} />
                                        )}
                                        <i className={`icon ${notify.type}`}>
                                            <i />
                                        </i>
                                        <div>
                                            <strong>{notify.title}</strong>
                                            <span>{notify.text}</span>
                                        </div>
                                    </li>
                                );
                            })}
                        </ul>
                    )}
                </div>
            </div>
        );
    }
}

export default UserNotifications;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/UserNotifications/UserNotifications.tsx